export default class EmailConfirmationExpired extends Error {
  name = 'EmailConfirmationExpired';

  constructor(readonly message = 'Email Confirmation Expired') {
    super(message);
  }
}
